var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 44,
    viewBox: "0 0 103 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "We Pick U Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.3585 24.8191L86.0488 36.4455V43.5714H80.7241V36.4455L74.4143 24.8191H80.3247L83.3864 31.4092L86.4481 24.8191H92.3585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M71.8762 43.5714L71.2373 41.1604H65.8593L65.2204 43.5714H59.4963L65.4334 24.8191H71.6633L77.6003 43.5714H71.8762ZM67.0042 36.8741H70.0925L68.5483 31.1145L67.0042 36.8741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.3791 38.3743H59.5025V43.5714H48.0544V24.8191H53.3791V38.3743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.2077 24.8191C42.1424 24.8191 43.7575 25.4352 45.0532 26.6675C46.3489 27.882 46.9967 29.5072 46.9967 31.5431C46.9967 33.5791 46.3489 35.2132 45.0532 36.4455C43.7575 37.6599 42.1424 38.2672 40.2077 38.2672H38.0779V43.5714H32.7532V24.8191H40.2077ZM40.2077 33.0701C40.616 33.0701 40.9621 32.9362 41.2461 32.6683C41.53 32.3825 41.672 32.0075 41.672 31.5431C41.672 31.0788 41.53 30.7127 41.2461 30.4448C40.9621 30.159 40.616 30.0162 40.2077 30.0162H38.0779V33.0701H40.2077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.9786 42.1516C22.5764 43.3839 20.7483 44 18.4942 44C16.2401 44 14.4119 43.3839 13.0097 42.1516C11.6076 40.9193 10.9065 39.303 10.9065 37.3028V24.8191H16.2312V36.7134C16.2312 38.1064 16.9855 38.8029 18.4942 38.8029C20.0028 38.8029 20.7572 38.1064 20.7572 36.7134V24.8191H26.0819V37.3028C26.0819 39.303 25.3808 40.9193 23.9786 42.1516Z",
    fill: "#73C947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M103 19.1809H97.0895L92.457 11.1442V19.1809H87.1323V0.428558H92.457V7.92948L96.8233 0.428558H102.734L97.196 9.53682L103 19.1809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M78.1539 19.6095C75.3495 19.6095 73.0244 18.6719 71.1785 16.7967C69.3326 14.9215 68.4097 12.5908 68.4097 9.80477C68.4097 7.01871 69.3326 4.68807 71.1785 2.81284C73.0244 0.937615 75.3495 0 78.1539 0C79.8755 0 81.464 0.410764 82.9195 1.23229C84.3749 2.05382 85.5108 3.1611 86.3273 4.55413L81.6948 7.23303C81.3931 6.62581 80.9227 6.14361 80.2837 5.78642C79.6448 5.42923 78.9348 5.25064 78.1539 5.25064C76.8404 5.25064 75.7755 5.67926 74.959 6.53651C74.1426 7.39376 73.7344 8.48318 73.7344 9.80477C73.7344 11.1264 74.1426 12.2158 74.959 13.073C75.7755 13.9303 76.8404 14.3589 78.1539 14.3589C78.9526 14.3589 79.6625 14.1803 80.2837 13.8231C80.9227 13.4659 81.3931 12.9748 81.6948 12.3497L86.3273 15.0286C85.5108 16.4395 84.3749 17.5557 82.9195 18.3772C81.464 19.1988 79.8755 19.6095 78.1539 19.6095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M61.6262 0.428558H66.9509V19.1809H61.6262V0.428558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M53.7795 0.428558C55.7142 0.428558 57.3293 1.04471 58.625 2.277C59.9207 3.49143 60.5685 5.11663 60.5685 7.1526C60.5685 9.18856 59.9207 10.8227 58.625 12.055C57.3293 13.2694 55.7142 13.8766 53.7795 13.8766H51.6496V19.1809H46.325V0.428558H53.7795ZM53.7795 8.67957C54.1878 8.67957 54.5339 8.54562 54.8178 8.27773C55.1018 7.99198 55.2438 7.61694 55.2438 7.1526C55.2438 6.68825 55.1018 6.32214 54.8178 6.05425C54.5339 5.7685 54.1878 5.62562 53.7795 5.62562H51.6496V8.67957H53.7795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.0071 14.2517H39.9292V19.1809H27.6824V0.428558H39.7961V5.30416H33.0071V7.34012H39.1305V12.1621H33.0071V14.2517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.27145 19.1809L0 0.428558H5.85716L8.38639 10.7423L11.3948 0.428558H15.4949L18.5033 10.7423L21.0325 0.428558H26.8897L21.6183 19.1809H16.3734L13.4449 9.16177L10.5163 19.1809H5.27145Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9c5dc5f7e8146c7a3d66cedc69137bd.svg";
export { ForwardRef as ReactComponent };